import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { PurchasingService } from '../../../services/purchasing.service';
import { Router } from '@angular/router';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
	selector: 'app-vendordash-invoice',
	templateUrl: './vendordash-invoice.component.html',
	styleUrls: ['./vendordash-invoice.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashInvoiceComponent implements OnInit {

	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();

	invoice: any = [];
	viewing: any = false;
	title: any = '';
	supplieridCache: any = {};
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	constructor(
		private purchasingService: PurchasingService,
		private router: Router,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.purchasingService.getPurchaseOrders().subscribe((results: any) => {
			if (results && results.grnready) {
				this.invoice = results.grnready;
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: 'Ready To Invoice' };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	navigateToPO(orderno: string) {
		if (this.supplieridCache[orderno]) {
			this.router.navigate(['/purchasing', this.supplieridCache[orderno], orderno]);
			return;
		}

		this.purchasingService.getPurchaseOrder(orderno).subscribe((result: any) => {
			if (result && result.poheader && result.poheader.supplierno) {
				const supplierid = result.poheader.supplierno;
				this.supplieridCache[orderno] = supplierid;
				this.router.navigate(['/purchasing', supplierid, orderno]);
			}
		});
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'ready-to-invoice.pdf',
			landscape: true,
			title: 'Ready To Invoice',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'ready-to-invoice.xlsx',
			title: 'Ready To Invoice',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

}
